"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.govDistributor6 = exports.govDistributor5b = exports.govDistributor5a = exports.govDistributor4 = void 0;
const govDistributor4 = {
    appId: 793119270,
};
exports.govDistributor4 = govDistributor4;
const govDistributor5a = {
    appId: 887391617,
};
exports.govDistributor5a = govDistributor5a;
const govDistributor5b = {
    appId: 902731930,
};
exports.govDistributor5b = govDistributor5b;
const govDistributor6 = {
    appId: 991196662,
};
exports.govDistributor6 = govDistributor6;
//# sourceMappingURL=mainnet-constants.js.map